import http from '../api/api'
import config from '../api/constants'

const getTermsAndConditions = async (data) => {
    try {
      const reqParams = {
        requestId: 'TERMS',
        type:"RETAIL",
        ...data,
      }
      const response = await http.post(config.apiRoute.GET_TERMS_AND_CONDITIONS, reqParams)
      return { status: response.status, data: response.data }
    } catch (err) {
      throw err.response.data
    }
  }

  const TermsConditionService = {
    getTermsAndConditions
  }
  export default TermsConditionService